import { useState, useEffect, useMemo, useCallback, memo } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { Carousel } from 'react-responsive-carousel';
import { OnboardCarouselProps } from '../../Services/CommonServices/propTypes';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import {isTutorial,onboardCarouselFadeOut, isTutoButnActive, isOnBoardHeader}  from "../../Services/Redux/Reducers/commonSlice";
import ReactPlayer from "react-player";
import { Cookies } from "react-cookie-consent";

const OnboardCarousel = ({ showMobileCarousel, isLoading, carouselData, showTutorialData, setShowTutorialData, handleGetStartedClick, handleSkip, blurBackground, isFadingOffElements, bucketUrl, cardFolder }) => {
  const [centerSlidePercentage, setCenterSlidePercentage] = useState(95);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isOnbaordAnimate, setIsOnbaordAnimate] = useState(false);
  const [userClosedTutorial, setUserClosedTutorial] = useState(false);
  const dispatch = useDispatch();
  const isTutoActive = useSelector((state)=>state.common.isTutorial);
  const locale = Cookies.get('locale') || 'en';
  
  const handleRedirect = useCallback(() => {
    setUserClosedTutorial(true);
    dispatch(isOnBoardHeader(true));
    setIsOnbaordAnimate(true);
    handleGetStartedClick();
    handleSkip();
    dispatch(isTutorial(false));
    dispatch(onboardCarouselFadeOut(true));
    dispatch(isTutoButnActive(false));
  }, [dispatch, handleGetStartedClick, handleSkip]);

  const images = useMemo(() => [
    `${bucketUrl}Dynamic_Pages/${cardFolder}/onboard_card1.png`,
    // '/static/assets/OnboardingImages/onboardimg2.png',
    `/static/assets/OnboardingImages/${locale}/onboard_card3.png`,
    `/static/assets/OnboardingImages/${locale}/onboard_card4.png`,
    `/static/assets/OnboardingImages/${locale}/onboard_card5.png`
  ], [bucketUrl, cardFolder, locale]);

  // Memoize the slides array to prevent recreation on every render
  const slides = useMemo(() => [
    {
      id: 'slide-1',
      image: images[0],
      headline: "Your Questions, Answered",
      subtext:
        "From special-occasion dressing to buying the perfect gift—what are you shopping for?",
    },
    // {
    //   id: 'slide-2',
    //   image: images[1],
    //   headline: "Exclusively Polo Styles",
    //   subtext:
    //     "Ask Ralph uses an extensive brand knowledge of men's and women's Polo products",
    // },
    {
      id: 'slide-3',
      image: images[1],
      headline: "OUTFITS FOR ANY OCCASION",
      subtext:
        "Ask Ralph will curate styles to fit your specific needs with a variety of pieces to choose from",
    },
    {
      id: 'slide-4',
      image: images[2],
      headline: "GIFTING MADE EASY",
      subtext:
        "For even those hard-to-shop-for loved ones, Ask Ralph will find the perfect gift",
    },
    {
      id: 'slide-5',
      image: images[3],
      headline: "HELP US IMPROVE",
      subtext:
        "Use the thumbs up and thumbs down icons within the Ask Ralph experience to provide feedback",
    },
  ], [images]);

  const totalSlides = slides?.length;
  const progressPercentage = ((currentSlide + 1) / totalSlides) * 100;
  

  useEffect(() => {
    const preloadImages = () => {
      images.forEach(src => {
        const img = new Image();
        img.src = src;
      });
    };
    
    if (images.length > 0) {
      preloadImages();
    }
  }, [images]);
  
  const handleNext = useCallback(() => {
    setCurrentSlide((prev) => (prev + 1) % totalSlides);
  }, [totalSlides]);

  const handleResize = useCallback(() => {
    if (window.innerWidth <= 390) {
      setCenterSlidePercentage(101.3);
    } else {
      setCenterSlidePercentage(98.8);
    }
  }, []);

  useEffect(() => {
    window.addEventListener('resize', handleResize);
    handleResize(); // Initial call to set the class based on initial window size

    return () => window.removeEventListener('resize', handleResize);
  }, [handleResize]);

   useEffect(() => {
     if (!userClosedTutorial &&
         showMobileCarousel &&
         !isLoading &&
         carouselData?.data?.length === 0 &&
         !carouselData?.isUserExist &&
         !showTutorialData) {
       setShowTutorialData(true);
       dispatch(isTutorial(true));
       dispatch(isTutoButnActive(true));
       dispatch(isOnBoardHeader(false));
     }
   }, [showMobileCarousel, isLoading, carouselData, showTutorialData, setShowTutorialData, dispatch, userClosedTutorial]);
  
   const showAnimation = useCallback((e) => {
     if(e?.animationName === "slidedown") {
       setShowTutorialData(false);
       setCurrentSlide(0);
     }
   }, [setShowTutorialData]);
  
  return (
    <div>
      {(showTutorialData) &&
      <>
      <div className={`onboard-tutorial-background ${isTutoActive && 'carousel-items'} ${!isTutoActive && 'carousel-slide-down'}`}>
        <ReactPlayer
          url={`${bucketUrl}Header_Background_Images/askralph_ambient_bg_launch.mp4`}
          playing
          loop={true}
          muted={true}
          playsinline={true}
          height="100%"
          width="100%"
        />
      </div>
        <div className={`carousel-container-onboard opacityCarousel  positionCarouselOnboard ${blurBackground && 'carousel-items'} ${isTutoActive && 'carousel-items'} ${!blurBackground && !isTutoActive && 'carousel-slide-down'} ${isFadingOffElements ? 'fade-out' : ''}`} onAnimationEnd={(e) => showAnimation(e)}>
          <div className={`carousel-container`} >
            <Carousel
              selectedItem={currentSlide}
              onChange={(index) => setCurrentSlide(index)}
              centerMode
              centerSlidePercentage={centerSlidePercentage}
              showThumbs={false}
              showStatus={false}
              showIndicators={false}
              showArrows={false}
              swipeable>
              {slides.map((slide, index) => (
                <div 
                  key={slide.id} 
                  className={`carousel-slide ${index === 0 ? 'firstcard' : index === 4 ? 'lastcard' : ''}`} 
                  style={index === 0 ? { marginLeft: "0px" } : index === 4 ? { marginRight: "-4px" } : { margin: "0" }}
                >
                  <img 
                    src={slide.image} 
                    alt={`Slide ${index + 1}`} 
                    style={{ width: "294px", height: "360px", borderRadius: "10px" }}
                    loading="eager"
                    decoding="async"
                  />
                </div>
              ))}
            </Carousel>
          </div>
          <div className={`footer opacityCarouselItems ${isOnbaordAnimate ? 'opacityCarouselItemsReverse' : ''}`}>
            <div className="px-3 d-flex justify-content-center">
              <div className="progress mt-4">
                <div className="progress-bar" style={{ width: `${progressPercentage}%` }}></div>
              </div>
            </div>
            <div className="d-flex mt-4 justify-content-center btn_margin">
              {progressPercentage === 100 ? (
                <button className="nextBtn" onClick={() => handleRedirect()}><span style={{ marginTop: "1px" }}>Get started</span>
                  <span style={{ marginLeft: '19px' }}>
                    <img
                      src="./static/assets/OnboardArrow.svg"
                      height="16px"
                      width="16px"
                      className="next-arrow"
                      alt='nextarrow'
                    />
                  </span>
                </button>
              ) : <button className="nextBtn" onClick={() => handleNext()} ><span style={{ marginTop: "1px" }}>Next</span>
                <span style={{ marginLeft: '19px' }}>
                  <img
                    src="./static/assets/OnboardArrow.svg"
                    height="16px"
                    width="16px"
                    className="next-arrow"
                    alt='nextarrow'
                  />
                </span>
              </button>
              }
            </div>
            <div className="text-center mt-3">
              <button name="skipTutorialButton" className="skip-text px-0" onClick={(() => handleRedirect())}>
                Close
              </button>
            </div>
          </div>
        </div>
      </>
      }
    </div>
  );
};

OnboardCarousel.propTypes = OnboardCarouselProps;

export default memo(OnboardCarousel);